import { ESessionStatus, ISessionFile } from "../session/type";

export interface IChatMessage {
  guidance?: string;
  type: EChatType;
  streamingStatus: EStreamDataStatus;
  send_msg?: IChatSendMessage[];
  files?: ISessionFile[]; // 用户上传文件
  send_time?: string;
  recv_msg: IChatRecvMessage[] | null;
  current_msg: IChatRecvMessage | null; // 当前流式数据
  cached_msg: IChatRecvMessage[] | null; // 当前缓存流式数据
  recv_time?: string;
  session_id: string;
  session_status?: ESessionStatus;
  parent_id?: string;
  message_id?: string;
  complete?: boolean; // 是否完成(停止生成时 = false)
  errCode?: number;
  score?: EChatScore;
  onSessionIdChange?: (value: string) => void;
  onSessionStatusChange?: (value: ESessionStatus) => void;
  status: EChatStatus;
  guess?: boolean;
  chatModel?: EChatModel;
  client_chan?: string;
  web_search?: boolean;
}

export interface IChatTextMessage {
  type: "text" | "url";
  content: string;
  fileId?: string;
}

export interface IChatSendMessage {
  msg_type: ESendMsgType;
  user_query?: string;
  trans_query?: string;
  file_query?: IFileQuery;
  ref_query?: IRefQuery;
}

export enum EChatModel {
  Video = "chatOnVideoCom",
  VideoR1 = "chatOnVideoR1",
  VideoEdit = "chatOnVideoEdit",
  R1 = "chatOnR1",
  Normal = "chatOnCom",
}

export enum ESendMsgType {
  user_query = "user_query",
  file_query = "file_query",
  trans_query = "trans_query",
}

export enum EFileQueryType {
  query = "query",
  summary = "summary",
  translation = "translation",
  explain = "explain",
  rewrite = "rewrite",
  expand = "expand",
  key_point = "key_point",
}

// 增加输入类型标记:wordage-文字,voice-语音,shoot-拍摄,picture-图片,file-文件,translation-翻译,regeneration-重新生成
// 优先级从低到高 regeneration > translation,file,picture,shoot > wordage,voice
export const enum EChatQueryType {
  regeneration = "regeneration",
  translation = "translation",
  file = "file",
  picture = "picture",
  wordage = "wordage",
  guess = "guess",
}
export interface IFileQuery {
  file_id: string;
  file_query_msg: string;
  file_query_type: EFileQueryType;
  location: string;
}

export interface ISelection {
  id: string;
  text: string;
  startPage: number;
  startId: string;
  startOffset: number;
  endPage: number;
  endId: string;
  endOffset: number;
}

export interface ISelectionDetail extends ISelection {
  top: number;
  left: number;
  right: number;
  bottom: number;
  width: number;
  height: number;
  mouseX: number;
  mouseY: number;
}

export interface IRefQuery {
  file_ids: string[];
  ref_query_msg: string;
  session_id: string;
}

export interface IChatUploadFile {
  id: string;
  name: string;
  url: string;
}

// export interface IChatRecvMessage {
//   status: EStreamDataStatus;
//   streamData?: IChatStreamData;
//   completedData?: IChatStreamData[];
// }

export interface IWebSearch {
  domain: string;
  icon: string;
  passage_or_snippet: string;
  title: string;
  type: string;
  url: string;
}

export interface IChatRecvMessage {
  text?: string;
  status?: EChatRecvStatus;
  tool_calls?: IStreamTool;
  type: EStreamDataType;
  text2image?: string;
  web_searcher?: IWebSearch[];
  reasoning_content?: string;
}

export enum EChatRecvStatus {
  text2image = "text2image",
  thinking = "thinking",
  web_searcher = "web_searcher",
  end = "end",
}

export enum EStreamDataType {
  text = "text",
  status = "status",
  thinking = "thinking",
  // tool_calls = "tool_calls",
  text2image = "text2image",
  web_searcher = "web_searcher",
  videoEdit = "videoEdit",
}

export enum EStreamDataStatus {
  init = "init",
  streaming = "streaming",
  streamingEnd = "streamingEnd",
}

export interface IStreamTool {
  name: string;
}

// export interface IStreamText {
//   value: string;
// }

export type TChatChannel = "";

export enum EChatType {
  history = "history",
  stream = "stream",
}

export enum EChatScore {
  like = 0,
  dislike = 1,
  default = 10000,
}

export enum EChatStatus {
  work = "work",
  input = "input", // 输入敏感
  output = "output", // 输出敏感
  thinkOutput = "think-output",
  bothOutput = "both-output",
  busy = "busy", // 用户繁忙
  key_point = "key_point", // 划重点
}

// 重新生成评价
export enum ERegenerateJudge {
  better = "better",
  worse = "worse",
  same = "same",
  cancel = "cancel",
}

export interface IChatTransLang {
  title: string;
  subTitle?: string;
  default?: boolean;
}
